<template>
    <div class="idom"></div>
</template>

<script>
    const IncrementalDOM = require('incremental-dom');

    const elementOpen = IncrementalDOM.elementOpen;
    const elementClose = IncrementalDOM.elementClose;
    const elementVoid = IncrementalDOM.elementVoid;
    const text = IncrementalDOM.text;

    const VoidElements = 'area base blockquote br col embed hr img input keygen link menuitem meta param source track wbr'.split(' ');
    const AllowedElements = 'a b i u em code mark sup sub img span iframe'.split(' ');
    const StandardBlocks = 'p h1 h2'.split(' ');
    const ListStyles = 'decimal lower-latin lower-roman'.split(' ');
    const TagPriority = 'cloze token math code a dfn mark sub sup b u i'.split(' ');

    let list = [];
    let cloze = 1;

    function RenderTagOpen(style, article){
        var max = -1, key, index = '?', classes = '', field;

        if(style.tag === 'cloze'){
            if(article.fields && article.fields.length){
                for(key = 0; key < article.fields.length; key++){
                    if(article.fields[key].id === style.id){
                        field = article.fields[key];
                        index = key + 1;
                        break;
                    }
                }
            }

            classes += article.editable ? 'editable ' : '';
            classes += article.go ? 'go' : 'placeholder';

            elementOpen(style.tag, null, null, 'guid', style.id, 'contenteditable', false, 'index', index, 'class', classes);

            if(article.go){
                elementVoid('input', null, null, 'guid', style.id, 'index', index, 'class', 'ib cloze-input reset-input go-complete-text-field', 'placeholder', field.label || 'Answer', 'value', article.responses[field.id] || '');
            }

        }else if(style.tag === 'math'){
            classes = (article.editable && !article.go) ? 'editable placeholder' : 'render';

            elementOpen(style.tag, null, null, 'guid', style.id, 'contenteditable', false, 'class', classes, 'latex', style.value || 'No Math Entered');
        }else if(style.tag === 'a'){
            elementOpen(style.tag, null, null, 'href', style.url, 'target', '_blank', 'alt', style.url);
        }else if(style.tag === 'dfn'){
            elementOpen(style.tag, null, null, 'alt', style.dfn);
        }else{
            elementOpen(style.tag);
        }
    }

    function SplitInstruction(addition, instructions, iteration){
        iteration = iteration || 1;
        if(iteration > 5){
            console.log('For some reason having issues');
            console.log(addition);
            console.log(instructions);
            return [];
        }

        for(var i = 0; i < instructions.length; i++){
            var instruction = instructions[i];
            //If addition bisects any of the instructions
            if(addition.start < instruction.start && addition.end > instruction.end){
                //Addition wraps the entire instruction and needs to be split into 3
                var a = Object.assign({}, addition, {start: addition.start, end: instruction.start}),
                b = Object.assign({}, addition, {start: instruction.start, end: instruction.end}),
                c = Object.assign({}, addition, {start: instruction.end, end: addition.end});

                return [].concat(SplitInstruction(a, instructions, iteration + 1), SplitInstruction(b, instructions, iteration + 1), SplitInstruction(c, instructions, iteration + 1));
            }else if(addition.start >= instruction.start && addition.start < instruction.end && addition.end > instruction.end){
                //Split into two
                var a = Object.assign({}, addition, {start: addition.start, end: instruction.end}),
                b = Object.assign({}, addition, {start: instruction.end, end: addition.end});

                return [].concat(SplitInstruction(a, instructions, iteration + 1), SplitInstruction(b, instructions, iteration + 1));
            }else if(addition.end <= instruction.end && addition.end > instruction.start && addition.start < instruction.start){
                //Split into two
                var a = Object.assign({}, addition, {start: addition.start, end: instruction.start}),
                b = Object.assign({}, addition, {start: instruction.start, end: addition.end});

                return [].concat(SplitInstruction(a, instructions, iteration + 1), SplitInstruction(b, instructions, iteration + 1));
            }
        }

        return [addition];
    }

    function RenderValue(block, article){
        var instructions = [];

        for(var i = 0; i < TagPriority.length; i++){
            var tag = TagPriority[i];

            //If there are no instructions of this type, just skip it
            if(!block.formatting || !block.formatting[tag] || !block.formatting[tag].length) continue;

            for(var j = 0; j < block.formatting[tag].length; j++){
                var addition = Object.assign({tag: tag}, block.formatting[tag][j]);
                instructions = instructions.concat(SplitInstruction(addition, instructions));
            }
        }

        instructions.sort((a, b) => {
            if(a.start < b.start) return -1;
            if(b.start < a.start) return 1;
            return (TagPriority.indexOf(a.tag) < TagPriority.indexOf(b.tag)) ? -1 : 1;
        });

        if(!instructions.length) return text(block.value);

        //Print out the first length of text, if there is some, before formatting begins
        var style, position = 0, stack = [];

        while(instructions.length){
            if(stack.length && stack[0].end <= instructions[0].start){
                //Need to close out on other tags first
                style = stack.shift();

                //Print out the preceding value
                text(block.value.substring(position, style.end));

                //Update our location in the text string
                position = style.end;

                //Close this one off the stack
                elementClose(style.tag);
            }else{
                //Ready for a new instruction
                style = instructions.shift();

                //Print out the preceding value
                text(block.value.substring(position, style.start));

                //Update our location in the text string
                position = style.start;

                //Open our new style tag
                RenderTagOpen(style, article);

                //If there are no more instructions, or this instruction ends before the next one starts
                if(!instructions.length || style.end <= instructions[0].start){
                    //Print out the rest of this tag and close it
                    text(block.value.substring(position, style.end));
                    position = style.end;
                    elementClose(style.tag);
                }else{
                    //Another tag opens before this one closes
                    stack.unshift(style);
                }
            }
        }

        //Close out any remaining tags on the stack
        while(stack.length){
            style = stack.shift();

            //Print out the preceding value
            text(block.value.substring(position, style.end));

            //Update our location in the text string
            position = style.end;

            //Close this one off the stack
            elementClose(style.tag);
        }

        //Print out the trailing string of chars (if any)
        text(block.value.substring(position));
    }

    function RenderBlock(block, article) {

        if(block.indent > list.length){
            for(var i = list.length, j = block.indent; i < j; i++){
                elementOpen(block.list || 'ul', null, null, 'class', ListStyles[(block.indent - 1) % 3], 'start', block.listStart || 1);
                list.unshift(block.list || 'ul');
            }
        }else if(block.indent < list.length){
            for(var i = block.indent, j = list.length; i < j; i++){
                elementClose(list.shift());
            }
        }

        if(block.tag === 'li' && block.list && block.list !== list[0]){
           //We need to start a new list with a different tag type
           elementClose(list.shift());
           elementOpen(block.list, null, null, 'class', ListStyles[(block.indent - 1) % 3]);
           list.unshift(block.list);
        }

        elementOpen(block.tag, null, null, 'block-id', block.id, 'class', (article.breakable ? 'tether-insertion-hotspot' : ''));

        (block.value || block.formatting.cloze && block.formatting.cloze.length || block.formatting.math && block.formatting.math.length) ? RenderValue(block, article) : elementVoid('br');

        elementClose(block.tag);
    }

    function RenderArticle(article) {
        cloze = 1;

        article.body.forEach(block => RenderBlock(block, article));

        if(list.length){
            list.forEach(type => elementClose(type));
            list = [];
        }
    }

    export default {
        name: 'IDOM',
        props: {
            configuration: Object
        },
        mounted(){
            return IncrementalDOM.patch(this.$el, RenderArticle, {
                body: this.configuration.body,
                fields: [],
                go: false
            });
        }
    }
</script>

<style lang="less">
    @import "~@/assets/less/variables";

    @fs: 18px;
    @lh: 26px;

    .idom
    {
        max-width: 800px;

        h2
        {
            color: @black;
            font-size: 32px;
            font-weight: 600;
            line-height: 36px;
            margin: 50px 0 10px;
        }

        p, ul, ol
        {
            margin: 30px 0;
            font-size: @fs;
            line-height: @lh;
            color: @darkgrey;

            &:last-child
            {
                margin-bottom: 0;
            }

            h3
            {
                padding: 0;
                margin-bottom: 0;
                font-size: 20px;
                margin-top: 30px;
            }
        }

        ul, ol
        {
            padding-left: 25px;
            list-style: disc;

            li
            {
                margin-bottom: 10px;
            }
        }

        ol
        {
            list-style: decimal;
        }

        h3 + p, h3 + ul, h3 + ol, h2 + p, h2 + ul, h2 + ol
        {
            margin-top: 10px;
        }

        li
        {
            font-size: @fs;
            line-height: @lh;
            color: @darkgrey;
        }

        ul > ul, ul > ol, ol > ul, ol > ol
        {
            margin: 0;
        }

        ol p, ul p
        {
            margin: 10px 0;
        }

        i
        {
            font-style: italic;
        }

        figure
        {
            margin: 50px 0;

            &:last-child
            {
                margin-bottom: 0;
            }

            h2
            {
                font-size: 12px;
                color: var(--primary-text-color);
                font-weight: 500;
                margin: 0;
                text-align: center;
            }

            img
            {
                background: #111;
                display: block;
                max-width: 100%;
                min-height: 100px;
                margin: 0 auto;
            }

            figcaption
            {
                font-size: 12px;
                margin: 10px 50px;
                line-height: 18px;
                color: var(--secondary-text-color);
                text-align: center;
            }

            table + figcaption
            {
                text-align: center;
            }
        }

        .math
        {
            font-size: 18px;
            color: #FFF;
            padding: 20px;
        }

        sup.footnote
        {
            a
            {
                border-bottom: 0;
            }
        }

        em
        {
            font-style: italic;

            &.bold
            {
                font-weight: 700;
                font-style: normal;
            }

            &.italics
            {
                font-style: italic;
            }
        }

        dfn
        {
            border-bottom: 1px dashed #AAA;
            font-style: normal;
        }

        a
        {
            color: #3a9bfc;
            text-decoration: none;
            border-bottom: 1px dashed #3a9bfc;
            cursor: pointer;

            &:hover, &:active
            {
                border-bottom-style: solid;
            }
        }

        sub, sup
        {
            margin-left: 2px;
            font-size: 0.6rem;
        }

        sup
        {
            vertical-align: super;
        }

        sub
        {
            vertical-align: sub;
        }

        em + sub, em + sup
        {
            font-style: italic;
        }

        b, strong
        {
            font-weight: 600;
        }

        table
        {
            margin: 0 auto;
            margin: 30px 50px;

            td
            {
                border-bottom: 1px solid #333;
                padding: 10px 20px 10px 0;

                &[align="center"]
                {
                    text-align: left;
                }

                &[align="left"]
                {
                    text-align: left;
                }

                &[align="right"]
                {
                    text-align: right;
                }

                p
                {
                    margin: 0;
                }
            }

            thead
            {
                td
                {
                    color: var(--primary-text-color);
                    // background: #222;
                }
            }

            tbody
            {
                tr:last-child
                {
                    td
                    {
                        border-bottom: 0;
                    }
                }
            }
        }
    }
</style>
